import { __rest } from "tslib";
import React from 'react';
import { default as IconComponent } from '@vtblife/uikit-icons';
import classNames from 'classnames';
import Control from './control';
import s from './dropdown.module.css';
const Icon = (_a) => {
    var { disabled, dataTest, onToggle } = _a, iconProps = __rest(_a, ["disabled", "dataTest", "onToggle"]);
    const size = iconProps.size || 'm';
    return (React.createElement(Control, { disabled: disabled, onToggle: onToggle },
        React.createElement("button", { type: "button", "data-test": dataTest, className: classNames(s.icon, disabled && s.disabled, s[size]) },
            React.createElement(IconComponent, Object.assign({}, iconProps)))));
};
export default Icon;
//# sourceMappingURL=icon.js.map